module.exports = __webpack_public_path__ + "img/icon-wlw.1c75cec7.png";